import getSelectedTableViewId from 'mini-mail-list-store/lib/utils/getSelectedTableViewId';
import { tryPrefetchMeetingMessage } from 'mini-mail-list-rsvp/lib/utils/tryPrefetchMeetingMessage';
/**
 * Fetch RichContentForRows on the tableview
 * @param tableViewId id of the table to perform the operation on
 */
export const fetchRichContentForRows = (tableViewId: string) => {
    // We should fetch rich content for current table view immediately and prefetch rest
    const shouldPrefetch = tableViewId !== getSelectedTableViewId();
    tryPrefetchMeetingMessage(shouldPrefetch);
};
